import { createRequestActions } from "common/helpers/action";

export const initCpKkmList = createRequestActions("CP.KKM.LIST.INIT");
export const scrollCpKkmList = createRequestActions("CP.KKM.LIST.SCROLL");
export const searchCpKkmList = createRequestActions("CP.KKM.LIST.SEARCH");
